"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4498],{

/***/ 64143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C8": function() { return /* binding */ postMissionRandomItems; },
/* harmony export */   "Le": function() { return /* binding */ fetchMissionEvent; },
/* harmony export */   "XB": function() { return /* binding */ postMissionComplete; },
/* harmony export */   "Xi": function() { return /* binding */ postCaptureCharacterId; },
/* harmony export */   "vl": function() { return /* binding */ postCaptureUUID; }
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39322);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

var fetchMissionEvent = function() {
    var _ref = _asyncToGenerator(function() {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/mission-event/")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchMissionEvent() {
        return _ref.apply(this, arguments);
    };
}();
var postMissionComplete = function() {
    var _ref = _asyncToGenerator(function(type) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/mission-event/complete/", {
                            type: type
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postMissionComplete(type) {
        return _ref.apply(this, arguments);
    };
}();
var postMissionRandomItems = function() {
    var _ref = _asyncToGenerator(function() {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/mission-event/random-items/")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postMissionRandomItems() {
        return _ref.apply(this, arguments);
    };
}();
var postCaptureCharacterId = function() {
    var _ref = _asyncToGenerator(function(id) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/play/chat-capture-share/", {
                            character_id: id
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postCaptureCharacterId(id) {
        return _ref.apply(this, arguments);
    };
}();
var postCaptureUUID = function() {
    var _ref = _asyncToGenerator(function(uuid) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/play/chat-capture-share/".concat(uuid, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postCaptureUUID(uuid) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 63732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fw": function() { return /* binding */ useBadgePresets; }
/* harmony export */ });
/* unused harmony export BadgeList */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71618);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91864);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        "px;\n  display: inline-block;\n  height: 18px;\n  line-height: 16px;\n  border-radius: ",
        "px;\n  font-weight: 500;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n        cursor: pointer;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n                  border: 1px solid transparent;\n                  background-image: linear-gradient(\n                      ",
        ",\n                      ",
        "\n                    ),\n                    ",
        ";\n                  background-origin: border-box;\n                  background-clip: content-box, border-box;\n                "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n                  border: 1px solid ",
        ";\n                  background-color: ",
        ";\n                "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n            ",
        "\n\n            span {\n              padding: 0 ",
        "px;\n            }\n          "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n                  background-image: ",
        ";\n                "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n                  background-color: ",
        ";\n                "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n            ",
        "\n\n            span {\n              padding: 0 ",
        "px;\n            }\n          "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      color: ",
        ";\n      ",
        "\n\n      ",
        "\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  font-size: 0;\n\n  * + * {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var badgeCSS = function(radius, fontSize) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject(), fontSize, radius);
};
var badgeColorCSS = function(color, backgroundColor) {
    var border = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isGradient = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, isClickable = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject8(), color, isClickable && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject1()), border ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject4(), isGradient ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject2(), theme.var.white, theme.var.white, backgroundColor) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject3(), backgroundColor, theme.var.white), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxhsmall */ .Ki.xxhsmall) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject7(), isGradient ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject5(), backgroundColor) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject6(), backgroundColor), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxsmall */ .Ki.xxsmall));
    };
};
var Badge = function(param) {
    var className = param.className, text = param.text, color = param.color, border = param.border, backgroundColor = param.backgroundColor, onClick = param.onClick, _radius = param.radius, radius = _radius === void 0 ? chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Radius.xsmall */ .wU.xsmall : _radius, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .FontSizes.xxsmall */ .TS.xxsmall : _fontSize;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.u)();
    var ref;
    var isGradient = (ref = backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.includes("linear-gradient")) !== null && ref !== void 0 ? ref : false;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
        css: [
            badgeCSS(radius, fontSize),
            badgeColorCSS(color !== null && color !== void 0 ? color : theme.true.white, backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.var.gray500, border, isGradient, !!onClick), 
        ],
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
            children: text
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Badge);
/** List Component */ var badgeListCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject9(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxsmall */ .Ki.xxsmall);
var BadgeList = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        css: badgeListCSS,
        children: children
    });
};
var useBadgePresets = function() {
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.u)();
    var presets = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            // fill
            grayFill: {
                backgroundColor: theme.var.gray400,
                color: theme.true.white
            },
            mainFill: {
                backgroundColor: theme.colors.main500,
                color: theme.true.white
            },
            blueFill: {
                backgroundColor: theme.colors.blue500,
                color: theme.true.white
            },
            pinkFill: {
                backgroundColor: theme.colors.pink500,
                color: theme.true.white
            },
            redFill: {
                backgroundColor: theme.colors.red500,
                color: theme.true.white
            },
            purpleFill: {
                backgroundColor: theme.service.violet,
                color: theme.true.white
            },
            honorFill: {
                backgroundColor: "linear-gradient(to right, #17dce4, #4db4ee)",
                color: theme.true.white
            },
            new: {
                backgroundColor: theme.colors.red500,
                color: theme.true.white
            },
            // border
            pink: {
                backgroundColor: theme.colors.pink500,
                border: true,
                color: theme.colors.pink500
            },
            yellow: {
                backgroundColor: theme.colors.yellow500,
                border: true,
                color: theme.colors.yellow500
            },
            orange: {
                backgroundColor: theme.colors.yellow700,
                border: true,
                color: theme.colors.yellow700
            },
            red: {
                backgroundColor: theme.colors.red500,
                border: true,
                color: theme.colors.red500
            },
            blue: {
                backgroundColor: theme.colors.blue500,
                border: true,
                color: theme.colors.blue500
            },
            main: {
                backgroundColor: theme.colors.main500,
                border: true,
                color: theme.colors.main500
            },
            fan: {
                backgroundColor: theme.colors.blue300,
                border: true,
                color: theme.colors.blue300
            },
            famousFill: {
                backgroundColor: "linear-gradient(35deg, #20A2AE 3.8%, #5563E1 84.21%)",
                color: theme.true.white
            }
        };
    }, []);
    return presets;
};


/***/ }),

/***/ 11502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11717);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26410);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_common_Overlay__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90814);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96964);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: rgba(0, 0, 0, 0.8) !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  overflow: scroll;\n\n  img {\n    max-width: 100%; /* width는 화면에 맞게 채움 */\n    max-height: 100%; /* height는 초과하지 않도록 제한 */\n    object-fit: contain; /* 비율 유지하며 width 채움 */\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var containerCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject(), (0,_styles_css__WEBPACK_IMPORTED_MODULE_2__/* .safeArea */ .BI)("top", "padding"), (0,_styles_css__WEBPACK_IMPORTED_MODULE_2__/* .safeArea */ .BI)("bottom", "padding"));
var imageContainerCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject1());
var ImageModal = function(_param) {
    var image = _param.image, props = _objectWithoutProperties(_param, [
        "image"
    ]);
    var onClose = props.onClose, open = props.open;
    if (!open) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {});
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_common_Overlay__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpreadProps(_objectSpread({}, props), {
        blocking: false,
        css: containerCSS,
        onClosePageClick: onClose,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            css: imageContainerCSS,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
                src: image.attachment.url,
                alt: "ground-image",
                layout: "intrinsic",
                loader: function(param) {
                    var src = param.src;
                    return src;
                },
                width: image.attachment.width,
                height: image.attachment.height,
                objectPosition: "center",
                objectFit: "contain"
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageModal);


/***/ }),

/***/ 68877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91864);
/* harmony import */ var _Frame__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19827);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  div:nth-of-type(1) {\n    width: ",
        ";\n    height: ",
        ";\n    border-radius: ",
        "px;\n    margin-bottom: ",
        "px;\n  }\n\n  div:nth-of-type(2) {\n    width: ",
        ";\n    height: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var situationSkeletonCSS = function(isDetail) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject(), isDetail ? "165px" : "100px", isDetail ? "165px" : "100px", chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Radius.medium */ .wU.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.xhsmall */ .Ki.xhsmall, isDetail ? "165px" : "100px");
};
var SituationSkeleton = function(param) {
    var isDetail = param.isDetail;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        css: situationSkeletonCSS(isDetail),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Frame__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Frame__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SituationSkeleton);


/***/ }),

/***/ 38283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useCharacterPost; }
/* harmony export */ });
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47311);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39953);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54909);
/* harmony import */ var _api_community__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1385);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39854);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30259);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45874);
/* harmony import */ var _utils_query__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96261);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81946);
/* harmony import */ var _useModal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48294);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











var useCharacterPost = function(feedCode) {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var web = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_9__/* .useWebView */ .B9)().web;
    var platform = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_6__/* .useGlobalContext */ .bN)().platform;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useQueryClient)();
    var imageModalName = "image-modal";
    var ref = _slicedToArray((0,_useModal__WEBPACK_IMPORTED_MODULE_10__/* .useModal */ .d)(imageModalName), 3), isImageModalOpen = ref[0], ref1 = ref[1], oepnImageModal = ref1.open, closeImageModal = ref1.close, selectedImage = ref[2];
    var optimistic = (0,_utils_query__WEBPACK_IMPORTED_MODULE_8__/* .useOptimisticUpdate */ .p7)();
    var ref2 = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useMutation)(_api_community__WEBPACK_IMPORTED_MODULE_4__/* .toggleCharacterPostLike */ .Yn), toggleLike = ref2.mutate;
    var ref3 = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useMutation)(function(postId) {
        return (0,_api_community__WEBPACK_IMPORTED_MODULE_4__/* .deleteCharacterPost */ .q1)(postId);
    }), removePost = ref3.mutate;
    var ref4 = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useMutation)(_api_community__WEBPACK_IMPORTED_MODULE_4__/* .patchCharacterPost */ .IM), updateCommunityPost = ref4.mutate;
    var likePost = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(post, characterId, query) {
        toggleLike(post.id, {
            onSuccess: function(param) {
                var isLiked = param.isLiked;
                optimistic.update(_constants__WEBPACK_IMPORTED_MODULE_5__/* .QUERY_KEYS.POST.CHARACTER_LIST */ .U7.POST.CHARACTER_LIST(characterId), function(post) {
                    return _objectSpreadProps(_objectSpread({}, post), {
                        isLiked: isLiked,
                        likeCount: post.likeCount + (isLiked ? 1 : -1)
                    });
                }, {
                    id: post.id
                });
                if (feedCode) {
                    queryClient.setQueryData(_constants__WEBPACK_IMPORTED_MODULE_5__/* .QUERY_KEYS.OUT_LOOK.GROUND_FEED */ .U7.OUT_LOOK.GROUND_FEED(feedCode, query), function(prevData) {
                        if (!prevData) return prevData;
                        var newData = _objectSpreadProps(_objectSpread({}, prevData), {
                            pages: prevData.pages.map(function(page) {
                                return _objectSpreadProps(_objectSpread({}, page), {
                                    items: page.items.map(function(item) {
                                        if ((item === null || item === void 0 ? void 0 : item.post) && item.post.id === post.id) {
                                            return _objectSpreadProps(_objectSpread({}, item), {
                                                post: _objectSpreadProps(_objectSpread({}, item.post), {
                                                    isLiked: isLiked,
                                                    likeCount: post.likeCount + (isLiked ? 1 : -1)
                                                })
                                            });
                                        } else {
                                            return item;
                                        }
                                    })
                                });
                            })
                        });
                        return newData;
                    });
                }
            }
        });
    }, []);
    var handleNavigatePostDetail = function(characterId, id, userId) {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_5__/* .Platform.web */ .t4.web) {
            router.push("/play/characters/".concat(characterId, "/posts/").concat(id).concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_7__/* .toQueryString */ .UK)({
                playerId: userId
            })));
        }
        web.openPage("/play/characters/".concat(characterId, "/posts/").concat(id).concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_7__/* .toQueryString */ .UK)({
            playerId: userId
        })));
    };
    var handleDeletePost = function(postId, characterId) {
        if (confirm(t("정말 게시글을 삭제하시겠습니까?"))) {
            removePost(postId, {
                onSuccess: function() {
                    queryClient.invalidateQueries(_constants__WEBPACK_IMPORTED_MODULE_5__/* .QUERY_KEYS.POST.CHARACTER_LIST */ .U7.POST.CHARACTER_LIST(characterId));
                    if (feedCode) {
                        queryClient.invalidateQueries(_constants__WEBPACK_IMPORTED_MODULE_5__/* .QUERY_KEYS.OUT_LOOK.GROUND_FEED_ALL */ .U7.OUT_LOOK.GROUND_FEED_ALL);
                    }
                }
            });
        }
    };
    var handleFixPost = function(postId, type, characterId) {
        var payload = {
            isFixed: type === "fix" ? true : false
        };
        updateCommunityPost(_objectSpread({
            postId: postId
        }, payload), {
            onSuccess: function(post) {
                queryClient.invalidateQueries(_constants__WEBPACK_IMPORTED_MODULE_5__/* .QUERY_KEYS.POST.CHARACTER_LIST */ .U7.POST.CHARACTER_LIST(characterId));
                web.mutate("update_character_community", post);
            },
            onError: function() {
                alert("게시글 고정을 할 수 없습니다.");
            }
        });
    };
    var handleClickTag = function(id, name) {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_5__/* .Platform.web */ .t4.web) {
            router.push("/play/characters/tags/".concat(id, "?title=").concat(name));
        } else {
            web.openPage("/play/characters/tags/".concat(id, "?title=").concat(name));
        }
    };
    var handleClickImg = function(img) {
        if (img) {
            oepnImageModal(img);
        }
    };
    var handleActionSheet = function(value, id, makerId, characterId) {
        switch(value){
            case "modify":
                queryClient.invalidateQueries(_constants__WEBPACK_IMPORTED_MODULE_5__/* .QUERY_KEYS.OUT_LOOK.GROUND_FEED_ALL */ .U7.OUT_LOOK.GROUND_FEED_ALL);
                if (platform === _constants__WEBPACK_IMPORTED_MODULE_5__/* .Platform.web */ .t4.web) {
                    router.push("/play/characters/posts/create".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_7__/* .toQueryString */ .UK)({
                        playerId: makerId,
                        postId: id
                    })));
                }
                web.openPage("/play/characters/posts/create".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_7__/* .toQueryString */ .UK)({
                    playerId: makerId,
                    postId: id
                })));
                break;
            case "delete":
                handleDeletePost(id, characterId);
                break;
            case "report":
                router.push("/report".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_7__/* .toQueryString */ .UK)({
                    objectType: _constants__WEBPACK_IMPORTED_MODULE_5__/* .ReportObjectType.character_community */ .LB.character_community,
                    objectId: id
                })));
                break;
            case "fix":
                handleFixPost(id, "fix", characterId);
                break;
            case "unfix":
                handleFixPost(id, "unfix", characterId);
                break;
            default:
                return;
        }
    };
    return {
        handleActionSheet: handleActionSheet,
        likePost: likePost,
        handleNavigatePostDetail: handleNavigatePostDetail,
        handleClickTag: handleClickTag,
        handleClickImg: handleClickImg,
        closeImageModal: closeImageModal,
        isImageModalOpen: isImageModalOpen,
        selectedImage: selectedImage
    };
};


/***/ })

}]);